import AssociatedProject from './AssociatedProject';
import withGS from '../../core/withGShoc';
import PropTypes from 'prop-types';
import React from 'react';
import ManageAssociatedProject from '../../core/project/ManageAssociatedProject';

class OntologyProjectAssociations extends React.Component {

    render() {

        const { data, entitlements, graph , lockedGraphs, projectType, location} = this.props;

        return (
            <ManageAssociatedProject
                associatedProjectComponent={AssociatedProject}
                graph={graph}
                location={location}
                lockedGraphs={lockedGraphs}
                projectType={projectType}
                entitlements={entitlements}
                data={data}
            />
        );
    }
}

OntologyProjectAssociations.propTypes = {
    id: PropTypes.string.isRequired,
    project: PropTypes.string,
    graph: PropTypes.string.isRequired,
    projectType: PropTypes.string.isRequired,
    ontologyProjects: PropTypes.array,
    entitlements: PropTypes.array,
    data: PropTypes.object.isRequired,
    lockedGraphs: PropTypes.array,
};

export default withGS(OntologyProjectAssociations);